var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 28,
    cy: 28.451,
    rx: 28,
    ry: 27.712,
    fill: "#10B1D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 20.53v16.165l12.834-8.083-12.834-8.082z",
    fill: "#fff"
  })));
}
export default SvgPlayIcon;